import { render, staticRenderFns } from "./SheerCurtainChoice.vue?vue&type=template&id=00c06ffe&scoped=true&"
import script from "./SheerCurtainChoice.vue?vue&type=script&lang=js&"
export * from "./SheerCurtainChoice.vue?vue&type=script&lang=js&"
import style0 from "./SheerCurtainChoice.vue?vue&type=style&index=0&id=00c06ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c06ffe",
  null
  
)

export default component.exports